import { render, staticRenderFns } from "./return-approval-step.vue?vue&type=template&id=4f6ce14e&"
import script from "./return-approval-step.vue?vue&type=script&lang=js&"
export * from "./return-approval-step.vue?vue&type=script&lang=js&"
import style0 from "./return-approval-step.vue?vue&type=style&index=0&id=4f6ce14e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports